export default "__VITE_ASSET__DubhXO5K__"